// extracted by mini-css-extract-plugin
module.exports = {"islandCommonButton":"style_islandCommonButton__G_xMy"};